import { useEffect } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import get from 'lodash/get';

const svgRegistry = !__SERVER__ && get(window, '__SERVER_CONTEXT__.svgRegistry', {}); // used only on client
let serverSideUsedSvg = {};

export function flushServerSideUsedSvg() {
    const copy = { ...serverSideUsedSvg };
    serverSideUsedSvg = {};
    return copy;
} // used in server only

/**
 * @return {null|portal}
 */
export default function SvgPortal({ children }) {
    const name = children.props.id;
    if (__SERVER__) {
        serverSideUsedSvg[name] = children;
        return null;
    }

    useEffect(() => {
        if (!svgRegistry[name]) {
            svgRegistry[name] = true;
            const container = document.querySelector('#svgSpriteContainer');
            container && container.insertAdjacentHTML('beforeend', renderToStaticMarkup(children));
        }
    }, [children]);

    return null;
}
